import { DefaultIntlFormatValues } from '@ratehub/base-ui';

import COMMON_MESSAGES from '../definitions/Messages';
import FooterDefaultIntlFormatValues from '../definitions/FooterDefaultIntlFormatValues';


/**
 * When we have an Anniversary bonus, it will be inserted as the new second item within `columns`.
 *
 * @param anniversaryBonus
 * @param columns
 * @param intl
 * @returns {void}
 */
function insertAnniversaryBonusColumn({ anniversaryBonus, columns, intl }) {
    if (anniversaryBonus?.points && anniversaryBonus?.value) {
        columns.splice(1, 0, intl.formatMessage(COMMON_MESSAGES.cardFooterAnniversaryBonus, {
            ...DefaultIntlFormatValues,
            ...FooterDefaultIntlFormatValues,
            anniversaryBonusPoints: anniversaryBonus.points,
            anniversaryBonusValue: anniversaryBonus.value,
        }));
    }
}

export default insertAnniversaryBonusColumn;
